import { IMapWidgetData, IMapWidgetStyle, MapWidgetData } from "@pageBuilder/typings";
import { StringUtil } from "../../utils/string-util";
import { WidgetRendererBase } from "./widget-renderer-base";

export class MapWidgetRenderer extends WidgetRendererBase<IMapWidgetData>{

    protected createNewInternal(): HTMLElement {
        return this.createWidgetElement("mapWidget");
    }

    protected renderInternal(element: HTMLElement, data: IMapWidgetData): HTMLElement {
        this.cleanupInternal(element);
        this.setBaseData(element, data);
        this.ensureIframe(element, data);
        this.renderStyles(element, data);

        return element;
    }

    protected renderStyles(element: HTMLElement, data: IMapWidgetData): void {
        this.renderBaseStyles(element, data.style);
    }

    private renderBaseStyles(element: HTMLElement, style: IMapWidgetStyle | null): void {
        if (style?.heightData?.height) {
            const elementHeight = `${style.heightData.height}px`;
            element.style.height = elementHeight;
            element.style.minHeight = elementHeight;
        } else {
            const elementHeight = `${MapWidgetData.defaultStyle.heightData?.height}px`;
            element.style.height = elementHeight;
            element.style.minHeight = elementHeight;
        }

        this.animationRenderer.setAnimationStyles(element, style?.animation);
    }

    private ensureIframe(element: HTMLElement, data: IMapWidgetData): void {
        let iframe = element.querySelector("iframe");

        if (!iframe) {
            const content = element.querySelector<HTMLDivElement>(".widget-content");
            iframe = document.createElement("iframe");
            iframe.style.border = "0";
            iframe.allowFullscreen = true;
            iframe.referrerPolicy = "no-referrer-when-downgrade";
            iframe.height = "100%";
            iframe.width = "100%";
            content?.append(iframe);
        }

        iframe.src = `/map-endpoint?q=${this.getAddress(data)}&zoom=${data.zoom}`;
        iframe.title = `Map ${data.addresses[0].coordinate.addressName}`;
    }

    private getAddress(data: IMapWidgetData): string {
        const defaultAddress = MapWidgetData.defaultAddresses[0].coordinate.addressName;
        const address = data.addresses[0].coordinate.addressName;

        return !StringUtil.isEmptyOrWhiteSpace(address)
            ? this.getCorrectAddress(address)
            : this.getCorrectAddress(defaultAddress);
    }

    private getCorrectAddress(incorrectAddress: string): string {
        const addressPart = incorrectAddress.split(",");
        let address: string = "";
        for(let i = 0; i < addressPart.length; i++) {
            addressPart[i] = addressPart[i].trim();
            if (addressPart[i].split(" ").length > 1) {
                address += "+" + addressPart[i].split(" ").join("+").trim();
                address += ",";
            } else {
                address += "+" + addressPart[i] + ",";
            }

        }
        return address.substring(1).slice(0, -1);
    }

    protected setBaseData(element: HTMLElement, data: IMapWidgetData): void {
        if (data.zoom) {
            element.setAttribute("data-zoom", data.zoom.toString());
        } else {
            element.removeAttribute("data-zoom");
        }

        if (data.addresses) {
            element.setAttribute("data-adresses", JSON.stringify(data.addresses));
        } else {
            element.removeAttribute("data-adresses");
        }
    }

    protected cleanupInternal(element: HTMLElement): void {
        const iframe = element.querySelector("iframe");

        if (iframe) {
            iframe.remove();
        }
    }

    protected getContentSelectorsInternal(element: HTMLElement): string[] {
        return [`#${element.id}`];
    }

}
